import React, { useState, useEffect } from "react";
import FloorCoverings from "../../../assets/img/Floor Coverings 1.svg";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import grass from "../../../assets/img/Artificial Grass 2.svg";
import garage from "../../../assets/img/Garage Door 3.svg";
import paint from "../../../assets/img/Interior Paint 4.svg";
import bath from "../../../assets/img/Bath 5.svg";
import windows from "../../../assets/img/Doors  Windows  6.svg";
import kitchen from "../../../assets/img/Kitchen 7.svg";
import { hitGetServicesCommonApi } from "../../../Redux/Common/GetServicesCommonSlice";
import { hitAddComingSoonUserApi } from "../../../Redux/Common/AddCominSoonUsersSlice";
import { showToast } from "../../../Helper/Toast";
import axios from "axios";
const ComingSoon = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    zipCode: "",
    mobileNumber: "",
    userType:
      location && location.state && location.state.clickBy
        ? location.state.clickBy
        : "",
    services: [],
    serviceNames: [],
  });
  const [serviceData, setServiceData] = useState([]);
  const [serviceNamesArray, setServiceNamesArray] = useState([]);

  useEffect(() => {
    initUserTypeTracking();
    dispatch(hitGetServicesCommonApi("all-services")).then((response) => {
      if (response.payload && response.payload.status === true) {
        setServiceData(response.payload.data.subServices);
      }
    });
  }, [dispatch]);


  // Helper to read cookies
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return '';
  }

  function initUserTypeTracking() {
    //console.log("[SR Tracking] Initializing user type tracking");
    const urlParams = new URLSearchParams(window.location.search);
    const urlUserType = urlParams.get("user_type");
    //console.log("[SR Tracking] URL user_type parameter:", urlUserType);

    if (urlUserType) {
      // Normalize the value (pro, homeowner, or unknown)
      const normalizedType = urlUserType.toLowerCase();
      if (normalizedType === "pro" || normalizedType === "homeowner") {
        localStorage.setItem(
          "sr_user_type",
          normalizedType === "pro" ? "Pro" : "Homeowner",
        );
        //console.log("[SR Tracking] User type set from URL:", normalizedType);
      }
    }
  }

  const services = [
    {
      id: "floor",
      label: "Floor Coverings",
      icon: <img src={FloorCoverings} alt="Floor Coverings" />,
    },
    {
      id: "grass",
      label: "Artificial Grass",
      icon: <img src={grass} alt="Artificial Grass" />,
    },
    {
      id: "garage",
      label: "Garage Door",
      icon: <img src={garage} alt="Garage Door" />,
    },
    {
      id: "paint",
      label: "Interior Paint",
      icon: <img src={paint} alt="Interior Paint" />,
    },
    {
      id: "bath",
      label: "Bath",
      icon: <img src={bath} alt="Bath" />,
    },
    {
      id: "windows",
      label: "Doors & Windows",
      icon: <img src={windows} alt="windows" />,
    },
    {
      id: "kitchen",
      label: "Kitchen",
      icon: <img src={kitchen} alt="Kitchen" />,
    },
  ];
  const handleServiceToggle = (serviceId) => {
    setFormData((prev) => ({
      ...prev,
      services: prev.services.includes(serviceId)
        ? prev.services.filter((s) => s !== serviceId)
        : [...prev.services, serviceId],
    }));
  };
  const handleServiceToggleWithName = (serviceName) => {
    setFormData((prev) => ({
      ...prev,
      serviceNames: prev.serviceNames.includes(serviceName)
        ? prev.serviceNames.filter((s) => s !== serviceName)
        : [...prev.serviceNames, serviceName],
    }));
  };
  const handleSubmit = async () => {
    if (
      !formData.fullName ||
      !formData.email ||
      !formData.zipCode ||
      !formData.userType
    ) {
      showToast("Please fill in all required fields", "error");
      return;
    }
    // check valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      showToast("Please enter a valid email address", "error");
      return;
    }



    // Add Facebook and page_url fields
    formData.fbc = getCookie('_fbc'); // Facebook click ID
    formData.fbp = getCookie('_fbp'); // Facebook browser ID
    formData.page_url = window.location.href; // Current page URL



    await dispatch(hitAddComingSoonUserApi(formData)).then(async (response) => {
      if (response.payload && response.payload.status === true) {
        await submitToSalesforce({
          fullName: formData.fullName, // Your full name state variable
          zipCode: formData.zipCode, // Your zip code state variable
          mobileNumber: formData.mobileNumber || "", // Your mobile number state variable
          email: formData.email, // Your email state variable
          iAmA: formData.userType, // 'Professional' or 'Client'
          services: formData.serviceNames, // Array like ['Kitchen', 'Bath']
        });
        showToast(
          "Thank you for your interest! We'll notify you when we launch.",
          "success",
        );
      } else {
        showToast(
          response.error.message || "Something went wrong. Please try again.",
          "error",
        );
      }
    });
  };
  // SHA-256 hash function for Meta Advanced Matching
  async function hashData(data) {
    if (!data) return "";
    const normalized = data.toString().toLowerCase().trim();
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(normalized);
    const hashBuffer = await crypto.subtle.digest("SHA-256", dataBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  }
  const submitToSalesforce = async (formData) => {
    // Parse name at the top
    const nameParts = formData.fullName.trim().split(" ");
    const firstName = nameParts.slice(0, -1).join(" ") || nameParts[0];
    const lastName = nameParts.slice(-1)[0] || formData.fullName;
    // Get UTMs from URL
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get("utm_source") || "";
    const utmMedium = urlParams.get("utm_medium") || "";
    const utmCampaign = urlParams.get("utm_campaign") || "";
    const utmContent = urlParams.get("utm_content") || "";
    const utmTerm = urlParams.get("utm_term") || "";
    // Hash PII for Meta Advanced Matching
    const hashedEmail = await hashData(formData.email);
    const hashedPhone = await hashData(formData.mobileNumber);
    const hashedFirstName = await hashData(firstName);
    const hashedLastName = await hashData(lastName);
    const hashedZip = await hashData(formData.zipCode);
    // Create hidden iframe for Salesforce submission
    const iframe = document.createElement("iframe");
    iframe.name = "salesforce_submit";
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    // Create form
    const form = document.createElement("form");
    form.method = "POST";
    form.action =
      "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00Dao00001Qijxf";
    form.target = "salesforce_submit";
    // Form fields
    const fields = {
      oid: "00Dao00001Qijxf",
      first_name: firstName,
      last_name: lastName,
      email: formData.email,
      zip: formData.zipCode,
      mobile: formData.mobileNumber,
      company: "Not Provided",
      "00NaZ00000RZbi1": formData.iAmA,
      "00NaZ00000RZybL": formData.services ? formData.services.join(", ") : "",
      "00NaZ00000UjJBh": localStorage.getItem("sr_user_type") || "Unknown", // <-- ADD THIS LINE
      // UTM FIELDS
      "00NaZ00000Tzb9IUAR": utmSource,
      "00NaZ00000Tzb9HUAR": utmMedium,
      "00NaZ00000Tzb9FUAR": utmCampaign,
      "00NaZ00000Tzb9GUAR": utmContent,
      "00NaZ00000Tzb9JUAR": utmTerm,
    };
    // Build form inputs
    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });
    // Submit to Salesforce
    document.body.appendChild(form);
    form.submit();
    // Push to GTM (fires Meta Pixel + GA4) with HASHED user_data
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "generate_lead",
      eventCallback: function () {
        setTimeout(() => {
          iframe.remove();
          form.remove();
          window.location.href = "/thank-you";
        }, 1000);
      },
      eventTimeout: 3000,
      user_data: {
        em: hashedEmail,
        ph: hashedPhone,
        fn: hashedFirstName,
        ln: hashedLastName,
        zp: hashedZip,
      },
    });
  };
  return (
    <div className="simple-renovate padding_top">
      <div className="container">
        <h1 className="logo">
          Simple<span className="logo-highlight">Renovate</span>
        </h1>
        <div className="coming-soon">
          <div>
            <span>Coming Soon</span>
          </div>
          <div className="underline"></div>
        </div>
        <p className="description">
          We're building the ultimate platform to connect homeowners with
          trusted renovation professionals.
        </p>
        <p className="cta-text">Be the first to know when we launch!</p>
        <div className="signup-form">
          <div className="form-group">
            <label>
              Full Name <span style={{ color: "#CC4645" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="John Doe"
              value={formData.fullName}
              onChange={(e) =>
                setFormData({ ...formData, fullName: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>
              Email Address <span style={{ color: "#CC4645" }}>*</span>
            </label>
            <input
              type="email"
              placeholder="john@example.com"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>
              Zip Code <span style={{ color: "#CC4645" }}>*</span>
            </label>
            <input
              type="tel"
              placeholder="12345"
              maxLength={6}
              value={formData.zipCode}
              onChange={(e) =>
                setFormData({ ...formData, zipCode: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>
              Phone Number <span style={{ color: "#CC4645" }}></span>
            </label>
            <input
              type="tel"
              placeholder="(123) 456-7890"
              value={formData.mobileNumber}
              maxLength={10}
              onChange={(e) =>
                setFormData({ ...formData, mobileNumber: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>
              I am a <span style={{ color: "#CC4645" }}>*</span>
            </label>
            <div className="toggle-buttons">
              <button
                type="button"
                className={formData.userType === "Professional" ? "active" : ""}
                onClick={() =>
                  setFormData({ ...formData, userType: "Professional" })
                }
              >
                Professional
              </button>
              <button
                type="button"
                className={formData.userType === "Client" ? "active" : ""}
                onClick={() => setFormData({ ...formData, userType: "Client" })}
              >
                Client
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>
              Services Interested In <span style={{ color: "#CC4645" }}>*</span>
            </label>
            <p className="hint">Select all that apply</p>
            <div className="services-grid">
              {serviceData.map((service) => (
                <button
                  key={service._id}
                  type="button"
                  className={`service-btn ${formData.services.includes(service._id) ? "selected" : ""
                    }`}
                  onClick={() => {
                    handleServiceToggle(service._id);
                    handleServiceToggleWithName(service.name);
                  }}
                >
                  <span className="service-icon">
                    {" "}
                    <img src={service.image} alt={service.name} />
                  </span>
                  <span className="service-label">{service.name}</span>
                </button>
              ))}
            </div>
          </div>
          <button onClick={handleSubmit} className="submit-btn">
            Notify Me When You Launch
          </button>
          <p className="disclaimer">
            By submitting this form, you agree to receive updates about
            SimpleRenovate.
          </p>
        </div>
      </div>
    </div>
  );
};
export default ComingSoon;
